import { render, staticRenderFns } from "./CancelShareTips.vue?vue&type=template&id=05d1d09d"
import script from "./CancelShareTips.vue?vue&type=script&lang=js"
export * from "./CancelShareTips.vue?vue&type=script&lang=js"
import style0 from "./CancelShareTips.vue?vue&type=style&index=0&id=05d1d09d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports